import { CONSULTANT_ROLES } from '@/common/constants/consultantRoles';

export const filterConsultantRoles = (users) =>
	users.filter((user) => CONSULTANT_ROLES.includes(user.role));
